import { SerializrAttributeContext } from '../schema/general/RootSchema';
export class SerializeAttributeContext extends SerializrAttributeContext {
    constructor(init) {
        super(init);
    }
    get value() {
        return this.objectContext.target[this.propName];
    }
}
